<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div style="display:flex;justify-content:flex-start;align-items:center;">
        <button-add @click="toAddPage" value="创建盘点任务" v-if="permissionCodes.indexOf('036011001') !== -1"></button-add>
        <div class="btn-box">
        </div>
      </div>
        <div class="btn-box">
          <span style="display: inline-block;color: #48576a;font-size: 14px;line-height: 30px;margin-right: 5px;">创建时间</span>
          <el-date-picker v-model="timevalue"  size="small" type="daterange" style="width: 280px;" range-separator="至"
                          start-placeholder="开始日期" end-placeholder="结束日期"
                          align="right" value-format="yyyy-MM-dd">
          </el-date-picker>
        </div>
      <input-search  placeholder="任务名称"  @search="searchKey" />
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" :operationArr="operationArr" :pageNum="requestData.pageNum" :pageSize="requestData.pageSize" @changePagination="changePagination" :total="total" @deleteLine="deleteLine" @goToModifyPage="goToModifyPage" @viewInventoryList="viewInventoryList" @viewInventoryReport="viewInventoryReport" @GenerateReport="GenerateReport" @changeSwitch="changeSwitch" @closeInventory="closeInventory" tableOperationWidth="400px" />
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/Material";
import { bus } from "../../../utils/bus";
import { errorHandler } from "../../../utils/errorHandler";
import ButtonAdd from "../../../components/common/buttons/button-add";
import { nSuccess } from "../../../utils/notice";

export default {
  components: {
    ButtonAdd,
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    Breadcrumb
  },
  name: "material-inventory",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "物资管理",
          name: "material-category-manage"
        },
        {
          value: "库存盘点"
        }
      ],
      fixTypeList: [],
      tableHead: [
        {
          prop: "taskName",
          label: "任务名称"
        },
        {
          prop: "createDate",
          label: "创建时间"
        },
        {
          prop: "deadlineDate",
          label: "截止时间"
        },
        {
          prop: "status",
          label: "关闭",
          closeInventory: true
        },
        // {
        //   prop: "status",
        //   label: "关闭",
        //   active: " ",
        //   inactive: "已关闭",
        //   isSwitch: true
        // },
        {
          prop: "memo",
          label: "备注"
        }
      ],
      tableData: [],
      requestData: {
        searchKey: "",
        pageSize: 10,
        pageNum: 1,
        startTime: "",
        endTime: ""
      },
      timevalue: [],
      total: 0,
      operationArr: ["viewInventoryList", "GenerateReport", "materialModify", "delete"]
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.getPage();
  },
  activated() {
    this.getPage();
  },
  methods: {
    getPage() {
      if (this.timevalue) {
        this.requestData.startTime = this.timevalue[0] || "";
        this.requestData.endTime = this.timevalue[1] || "";
      } else {
        this.requestData.startTime = "";
        this.requestData.endTime = "";
      }
      this.$axios
        .post(api.getMaterialsStatisticTaskPage, this.requestData)
        .then(res => {
          this.total = res.data.data.total;
          let list = res.data.data.list;
          list.map(v => {
            if (v.finished) {
              v.status = false;
            } else {
              v.status = true;
            }
          });
          this.tableData = list;
          // console.log(this.tableData);
        })
        .catch(errorHandler("获取分页列表失败"));
    },
    toAddPage() {
      this.$router.push({
        name: "consuming-inventory-add"
      });
    },
    changePagination(data) {
      this.requestData.pageNum = data[0];
      this.requestData.pageSize = data[1];
      this.getPage();
    },
    changeSwitch(data) {
      this.$confirm(
        "确定关闭此盘点任务吗？下线之后将无法重新盘点此项目！",
        "提示"
      )
        .then(() => {
          for (let i in data) {
            if (data[i] === "--") {
              data[i] = "";
            }
          }
          if (data.detailMap === "") {
            data.detailMap = null;
          }

          if (data.finished) {
            nError("已关闭的项目无法开启");
            this.getPage();
          } else {
            let data1 = {};
            data.finished = true;
            data1.finished = data.finished;
            data1.code = data.code;
            this.$axios
              .post(api.updateMaterialsStatisticTask, data1)
              .then(res => {
                nSuccess("修改成功");
                this.getPage();
              })
              .catch(errorHandler("修改失败"));
          }
        })
        .catch(() => {
          this.getPage();
        });
    },
    deleteLine(code) {
      this.$axios
        .post(api.deleteMaterialsStatisticTaskByCodes, code)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("删除成功");
            this.getPage();
          }
        })
        .catch(errorHandler("删除失败"));
    },
    goToModifyPage(code) {
      this.$router.push({
        path: `/consuming_inventory_modify/${code}`
      });
    },
    viewInventoryList(code) {
      this.$router.push({
        path: `/stock_inventory_list/${code}`
      });
    },
    viewInventoryReport(code) {
      this.$router.push({
        path: `/stock_inventory_report/${code}`
      });
    },
    searchKey(v) {
      this.requestData.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    closeInventory(data) {
      this.$confirm(
        "确定关闭此盘点任务吗？下线之后将无法重新盘点此项目！",
        "提示"
      )
        .then(() => {
          for (let i in data) {
            if (data[i] === "--") {
              data[i] = "";
            }
          }
          if (data.detailMap === "") {
            data.detailMap = null;
          }

          if (data.finished) {
            nError("已关闭的项目无法开启");
            this.getPage();
          } else {
            let data1 = {};
            data.finished = true;
            data1.finished = data.finished;
            data1.code = data.code;
            this.$axios
              .post(api.updateMaterialsStatisticTask, data1)
              .then(res => {
                nSuccess("修改成功");
                this.getPage();
              })
              .catch(errorHandler("修改失败"));
          }
        })
        .catch(() => {
          this.getPage();
        });
    },
    GenerateReport(code) {
      this.$axios
        .post(api.generateReport, { taskCode: code })
        .then(res => {
          nSuccess("生成报表成功");
        })
        .catch(errorHandler("生成报表失败"));
    }
  },
  watch: {
    timevalue() {
      this.getPage();
    }
  }
};
</script>


<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less">
.el-input--small .el-input__inner {
  line-height: 30px;
}
.btn-box {
  .el-date-editor .el-range-separator {
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/MaterialManagement/ConsumingInventory/ConsumingInventory.vue